import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form/immutable';
import { connect } from 'react-redux';
import { compose, branch, withProps } from 'recompose';
import { request } from '../../../lib/Actions';
import Widget from '../../../components/Form/Widget/Widget';
import { RESOURCE_PLACES_FORM } from '../constants';
import * as actions from '../actions';
import * as selectors from '../selectors';
import * as styles from './styles.css';
import { ButtonSmall } from '../../../components/Button/index';
import GeoSearch from '../../../components/Form/GeoSearch/GeoSearchContainer';
import * as resourceSelectors from '../../../entities/Resource/selectors';
import { areasByIds } from '../../../entities/Area/selectors';
import { useTranslation } from 'react-i18next';

const PLACES_FIELD = 'areas';

function PlacesForm({
  handleSubmit,
  isLoading,
  actionInProgress,
  isEditable,
  toggleEditable,
  reset,
  currentUserId,
  widgetInView,
  isConsultantPortal,
  initialValues,
  forceCloseEditMode,
  setForceCloseEditMode
}) {
  const { t } = useTranslation();
  if (!widgetInView)
    widgetInView = 'general';

  if (!currentUserId)
    currentUserId = 0

  let widgetExpandStatus = localStorage.getItem('UID_' + currentUserId + '_Intresseområden_isExpanded_' + widgetInView) === "false" ? false : true;
  const [isExpanded, setIsExpanded] = useState(widgetExpandStatus);

  const [selectedAreas, setSelectedAreas] = useState([]);
  const [initLoad, setInitLoad] = useState(true);
  const [isLoading2, setIsLoading] = useState(actionInProgress);
  
  useEffect(() => {
    if(initLoad && isConsultantPortal && initialValues && initialValues.toJS){
      let areasData = initialValues.toJS()
      setSelectedAreas(areasData.areas)
      setInitLoad(false)
    }
  }, [initialValues]);

  useEffect(() => {
    setIsLoading(actionInProgress)
  }, [actionInProgress]);

  useEffect(() => {
    if(forceCloseEditMode){
      toggleEditable()
      setForceCloseEditMode(false)
    }
  }, [forceCloseEditMode]);

  const handleWidgetExpand = () => {
    setIsExpanded(!isExpanded)
    localStorage.setItem('UID_' + currentUserId + '_Intresseområden_isExpanded_' + widgetInView, !isExpanded);
  }

  const cancel = () => {
    if (!isExpanded)
      setIsExpanded(!isExpanded)
    toggleEditable();
    reset();
  };

  return (
    <Widget
      title={t("Intresseområden")}
      toggleEditable={cancel}
      className={`${styles.form} ${isExpanded ? 'expanded' : 'collapsed'}`}
      footer={
        isExpanded && isEditable && (
          <Widget.Footer>
            <ButtonSmall onClick={cancel} icon="ban" variant="danger">{t("Avbryt")}</ButtonSmall>
            <ButtonSmall onClick={()=>{
              console.log('places form consultat',selectedAreas)
              handleSubmit(selectedAreas);
            }} icon="cloud" variant="primary">{t("Spara")}</ButtonSmall>
          </Widget.Footer>
        )
      }
      isLoading={isLoading2}
      widgetVisibilityControls={
        <ButtonSmall onClick={handleWidgetExpand} className="widgetCollapseBtn">
          {isExpanded ? <i className="fa fa-minus-square-o" /> : <i className="fa fa-plus-square-o" />}
        </ButtonSmall>
      }
    >
      {isExpanded && handleSubmit && (
        <Field
          label={t("Intresseområden")}
          name={PLACES_FIELD}
          component={GeoSearch}
          isEditable={isEditable}
          showMap={false}
          isConsultantPortal={isConsultantPortal}
          onChange={(event, newValue) => {
            setSelectedAreas(newValue.toJS())
          }}
        />
      )}
    </Widget>

  );
}

PlacesForm.defaultProps = {
  isEditable: false,
  isLoading: false,

};

PlacesForm.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggleEditable: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

function mapStateToProps(state, { id }) {
  const resource = resourceSelectors.resourceById(state, id);
  const areas = (resource && resource.areas) ? areasByIds(state, resource.areas) : undefined;
  return {
    isEditable: selectors.placesForm.isEditable(state),
    isLoading: selectors.placesForm.isLoading(state),
    initialValues: { areas },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleEditable: () => dispatch(request(actions.placesForm.TOGGLE_EDITABLE)()),
  };
}

const mapAreas = (area) => {
  if (area.geoCode) {
    return {
      geoCode: area.geoCode,
    };
  }

  return {
    name: area.name,
    secondaryName: area.secondaryName,
    distance: area.distance,
    coordinates: area.coordinates,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ initialValues: { areas } }) => typeof areas === 'undefined',
    withProps({
      waitForAreas: true,
    }),
    reduxForm({
      form: RESOURCE_PLACES_FORM,
      forceUnregisterOnUnmount: true,
      enableReinitialize: true,
      keepDirtyOnReinitialize: false,
      onSubmit: (values, dispatch, props) => {
        const sendValues = values
          .toJS()[PLACES_FIELD]
          .map(mapAreas);
        dispatch(
          request(actions.UPDATE)({
            id: props.id,
            form: props.form,
            values: {
              [PLACES_FIELD]: sendValues,
            },
          }),
        );
      },
    }),
  ),
)(PlacesForm);
